import {faqQuestionClick} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withFaqQuestionEvent = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, faqQuestionClick, options)

export default withFaqQuestionEvent
